import { t } from '../../services/locale';
import type { ProfileCredit, ProfileDateFormatters, ProfileMembershipBranch } from './profileMembership.types';
import { getBranchDateFormat } from './profileMembershipRules';

export function getCreditStartDate(
  credit: ProfileCredit | null | undefined,
  branch: ProfileMembershipBranch | null | undefined,
  formatUnix: ProfileDateFormatters['formatUnix']
): string {
  if (!credit?.start_date) {
    return t('WEB_START_AT_FIRST_BOOKING');
  }
  return `${t('WEB_STARTING_DATE')}: ${formatUnix(credit.start_date, getBranchDateFormat(branch))}`;
}

export function getCreditExpiryDate(
  credit: ProfileCredit | null | undefined,
  branch: ProfileMembershipBranch | null | undefined,
  formatUnix: ProfileDateFormatters['formatUnix']
): string {
  if (!credit?.end_date) {
    return t('WEB_DONT_EXPIRE');
  }
  return `${t('WEB_EXPIRY_DATE')}: ${formatUnix(credit.end_date, getBranchDateFormat(branch))}`;
}
